<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12" v-if="taskInfo">
            <a-form-item label="状态" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-radio-group buttonStyle="solid" v-decorator="['questionStatus', validatorRules.questionStatus]">
                <a-radio-button :value="0"> 草稿 </a-radio-button>
                <a-radio-button :value="1"> 提交审核 </a-radio-button>
                <a-radio-button v-has="'question:review'" :value="-1"> 请重新修改 </a-radio-button>
                <a-radio-button v-has="'question:review'" :value="2"> 审核通过 </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="!taskInfo">
            <a-form-item label="状态" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <j-dict-select-tag
                type="radioButton"
                v-decorator="['questionStatus', validatorRules.questionStatus]"
                :trigger-change="true"
                dictCode="question_status"
                placeholder="请选择状态"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-has="'question:review'">
            <a-form-item label="题库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="radioButton"
                v-decorator="['questionLibrary', validatorRules.questionLibrary]"
                :trigger-change="true"
                dictCode="question_library"
                placeholder="请选择题库"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="题型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                @change="questionTypeChange"
                type="radioButton"
                v-decorator="['questionType', validatorRules.questionType]"
                :trigger-change="true"
                dictCode="question_type"
                placeholder="请选择题型"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="知识点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-category-select v-decorator="['knowledgePoint']" pcode="A07" multiple showFullPath placeholder="请选择知识点" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="题目标签" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-category-select v-decorator="['tag']" @change="onTagChange" pcode="A04" showFullPath multiple placeholder="请选择题目标签" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="tagConfig">
            <a-form-item label="题目标签设置" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-row>
                <a-col :span="10">标签</a-col>
                <a-col :span="4">权重</a-col>
              </a-row>
              <a-row v-for="(v, k, i) in tagConfig" :key="i">
                <a-col :span="10">{{filterMultiDictText(dictOptions['tag'], k)}}</a-col>
                <a-col :span="4"><a-input v-model="v.score"></a-input></a-col>
              </a-row>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="难度" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-radio-group buttonStyle="solid" v-decorator="['questionDifficulty', validatorRules.questionDifficulty]">
                <a-radio-button :value="1"> 易 </a-radio-button>
                <a-radio-button :value="2"> 中 </a-radio-button>
                <a-radio-button :value="3"> 难 </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="参考分值" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :min="0" v-decorator="['questionScore',validatorRules.questionScore]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="题目名" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-input  v-decorator="['questionName',validatorRules.questionName]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="题干" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor @change="questionStemChange" :value="questionStem" :triggerChange="true" 
                toolbar="| formatselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify subscript	superscript removeformat | lists image media table codesample | removeformat code |"/>
              <a-tag color="blue" v-if="model.questionType == 4">三个以上的下划线代表一个空位，如“电脑诞生于____年，名字叫______”</a-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="读题文本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-row>
                <a-col :span="20">
                  <a-textarea placeholder="请输入读题文本，留空则自动生成" v-decorator="['voiceText']" @change="e=>model.voiceText=e.target.value" :autosize="{ minRows: 3, maxRows: 10 }"></a-textarea>
                </a-col>
                <a-col :span="4">
                  <a-divider type="vertical"></a-divider>
                  <Voice :text="model.voiceText" size="20px"/>
                </a-col>
              </a-row>
              
              
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="model.questionType == 7 || model.questionType == 8">
            <a-form-item label="代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-row>
                <a-col :span="8">
                  <j-dict-select-tag
                    style="width: 200px"
                    type="list"
                    v-decorator="['codeType', validatorRules.codeType]"
                    :trigger-change="true"
                    dictCode="code_type"
                    placeholder="请选择代码类型"
                  />
                </a-col>
                <a-col :span="8">
                  <a-tooltip >
                    <span slot="title">使用模板，学生不用手动编写外围代码，直接编写中间缺失的代码实现即可</span>
                    <j-upload
                      style="display:inline-block"
                      v-decorator="['questionStemFile']"
                      text="模板文件"
                      :uploadTarget="'qiniu'"
                      :number="1"
                      :trigger-change="true"
                    ></j-upload>
                  </a-tooltip>
                </a-col>
                <a-col :span="8">
                  <a-tooltip >
                    <span slot="title">考试期间对学生不可见</span>
                    <j-upload
                      v-decorator="['questionAnalysisFile']"
                      text="参考答案"
                      :uploadTarget="'qiniu'"
                      :number="1"
                      :trigger-change="true"
                    ></j-upload>
                  </a-tooltip>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
          
          <a-col :span="12" v-if="model.questionType == 8">
            <a-form-item label="输入描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['inputDesc',validatorRules.inputDesc, { trigger: 'input' }]" triggerChange
                toolbar="| formatselect | forecolor bold  image table codesample"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model.questionType == 8">
            <a-form-item label="输出描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['outputDesc',validatorRules.outputDesc, { trigger: 'input' }]" triggerChange
                toolbar="| formatselect | forecolor bold  image table codesample"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model.questionType == 8">
            <a-form-item label="输入样例" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['inputCase',validatorRules.quinputCaseestionName]"></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model.questionType == 8">
            <a-form-item label="输出样例" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['outputCase',validatorRules.outputCase]"></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model.questionType == 8">
            <a-form-item label="时间限制" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-input v-decorator="['timeLimit',validatorRules.timeLimit]" suffix="秒" type="number" :min="1" :max="99" style="width:100px"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model.questionType == 8">
            <a-form-item label="内存限制" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-input v-decorator="['memLimit',validatorRules.memLimit]" suffix="MB" type="number" :min="1" :max="999" style="width:100px"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="model.questionType == 8">
             <a-form-item label="测试用例" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <p>作为检验考生程序并计算得分的测试数据，考生不可见</p>
                <a-card>
                  <a-row>
                    <a-col :span="6">用例名称</a-col>
                    <a-col :span="4">分数</a-col>
                    <!-- <a-col :span="4">输入数据</a-col> -->
                    <!-- <a-col :span="4">输出数据</a-col> -->
                    <a-col :span="4">操作</a-col>
                  </a-row>
                  <a-divider></a-divider>
                  <a-row v-for="(c,i) in testCase" :key="i">
                    <a-col :span="6">{{c.name}}</a-col>
                    <a-col :span="4">{{c.score}}</a-col>
                    <!-- <a-col :span="4">{{calcByte(c.input)}}</a-col> -->
                    <!-- <a-col :span="4">{{calcByte(c.output)}}</a-col> -->
                    <a-col :span="4">
                      <a-icon type="edit" @click="editCase(i)"/>
                      <a-divider type="vertical"/>
                      <a-popconfirm title="确定删除吗?" @confirm="() => deleteCase(i)">
                          <a-icon type="delete" />
                        </a-popconfirm>
                    </a-col>
                  </a-row>
                </a-card>

                <a-row>
                  <a-col :span="6"><a-button @click="addCase">添加测试用例</a-button></a-col>
                  <a-col :span="12">题目总分: {{this.model.questionScore}}</a-col>
                </a-row>
              </a-form-item>
          </a-col>

          <a-col :span="24" v-show="model.questionType==1 || model.questionType==2 || model.questionType==4">
            <a-form-item label="选项" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['questionOptions']" placeholder="请输入选项"></a-input> -->
              <!-- 单选题选项和答案 -->
              <a-radio-group v-if="model.questionType == 1" v-model="radioValue">
                <a-radio v-for="(o, i) in options" :key="i" :value="i">
                  {{ index2letter(i) }}
                  <a-divider type="vertical" />
                  <a-button shape="circle" type="primary" icon="up" @click="moveUpOption(i)" :disabled="i == 0" />
                  <a-button
                    shape="circle"
                    type="primary"
                    icon="down"
                    @click="moveDownOption(i)"
                    :disabled="i == options.length - 1"
                  />
                  <a-button shape="circle" type="danger" icon="delete" @click="delOption(i)" />
                  <j-editor @change="(v)=>{o.item=v}" :value="o.item" triggerChange toolbar="| formatselect | forecolor backcolor bold italic |alignleft aligncenter alignright alignjustify  | lists link unlink image media table codesample  | removeformat code |"/>
                </a-radio>
                <a-button @click="addOption" type="primary">添加选项</a-button>
              </a-radio-group>
              <!-- 多选题选项和答案 -->
              <a-checkbox-group v-show="model.questionType == 2" v-model="checkboxValue">
                <a-checkbox v-for="(o, i) in options" :key="i" :value="i">
                  {{ index2letter(i) }}
                  <a-divider type="vertical" />
                  <a-button shape="circle" type="primary" icon="up" @click="moveUpOption(i)" :disabled="i == 0" />
                  <a-button
                    shape="circle"
                    type="primary"
                    icon="down"
                    @click="moveDownOption(i)"
                    :disabled="i == options.length - 1"
                  />
                  <a-button shape="circle" type="danger" icon="delete" @click="delOption(i)" />
                  <j-editor  @change="(v)=>{o.item=v}" :value="o.item" triggerChange toolbar="| formatselect | forecolor backcolor bold italic |alignleft aligncenter alignright alignjustify  | lists link unlink image media table codesample  | removeformat code |"/>
                </a-checkbox>
                <a-button @click="addOption" type="primary">添加选项</a-button>
              </a-checkbox-group>
              <!-- 填空题空位和答案 -->
              <div v-if="model.questionType == 4">
                <div v-for="(v, i) in gapFillValue" :key="i">
                  <a-select
                    v-model="v.item"
                    :placeholder="'第' + (i + 1) + '空答案'"
                    mode="tags"
                    style="width: 100%"
                    :token-separators="[',']"
                  >
                  </a-select>
                </div>
                <a-tag>每个空位可填写多个同义答案。</a-tag>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-show="model.questionType==3 || model.questionType==5">
            <a-form-item label="答案" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- 判断题答案 -->
              <a-switch
                v-if="model.questionType == 3"
                v-model="switchValue"
                checked-children="正确"
                un-checked-children="错误"
              />
              <!-- 主观题关键词 -->
              <div v-if="model.questionType == 5">
                <a-select
                  v-model="keywordsValue"
                  placeholder="填写关键词"
                  mode="tags"
                  style="width: 100%"
                  :token-separators="[',']"
                >
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          
          <a-col :span="24">
            <a-form-item label="解析" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['questionAnalysis']" :triggerChange="true"
               toolbar="| formatselect | forecolor backcolor bold italic |alignleft aligncenter alignright alignjustify  | lists link unlink image media table codesample  | removeformat code |"/>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="关联课程单元" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['unitId']" dict="teaching_course_unit,unit_name,id" />
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item label="批注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['comment']" placeholder="请输入批注"></a-textarea>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <a-modal :width="600" :visible="showCase" title="编辑用例" @ok="confirmCase" @cancel="closeCase" okText="确定">
      <a-form >
        <a-form-item label="用例名">
            <a-input v-model="currentCase.name"></a-input>
        </a-form-item>
        <a-form-item label="分数">
            <a-input-number v-model="currentCase.score" :min="0"></a-input-number>
        </a-form-item>
        <a-form-item label="运行输入">
            <a-textarea v-model="currentCase.input"></a-textarea>
        </a-form-item>
        <a-form-item label="运行输出">
            <a-textarea v-model="currentCase.output"></a-textarea>
        </a-form-item>
        <a-form-item label="程序关键字">
          <a-row type="flex" justify="space-around">
            <a-col :span="11">
                <p>包含：</p>
                <a-textarea addonBefore="afdsd" v-model="currentCase.include"></a-textarea>
            </a-col>
            <a-col :span="11">
                <p>不包含：</p>
                <a-textarea v-model="currentCase.exclude"></a-textarea>
            </a-col>
            <a-col :span="23">
                <p>正则表达式：</p>
                <a-textarea v-model="currentCase.reg"></a-textarea>
                <a-radio-group v-model="currentCase.regType" button-style="solid">
                  <a-radio-button value="find"> 查找 </a-radio-button>
                  <a-radio-button value="matchers"> 全匹配 </a-radio-button>
                </a-radio-group>
                <a-divider type="vertical"></a-divider>
                <a-button type="primary" @click="regexTest(currentCase.reg,currentCase.regType)">正则测试</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
    <RegexTest ref="regexTestModal"/>
  </a-spin>
</template>

<script>
import Vue from 'vue'
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import {DisabledAuthFilterMixin} from '@/mixins/DisabledAuthFilterMixin'
import { loadCategoryData } from '@/api/api'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JUpload from '@/components/jeecg/JUpload'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import JEditor from '@/components/jeecg/JEditor'
import JCategorySelect from '@/components/jeecg/JCategorySelect'
import RegexTest from '@/components/tools/RegexTest'
import Voice from '@/components/tools/Voice'
export default {
  name: 'TeachingQuestionForm',
  components: {
    JFormContainer,
    JUpload,
    JDictSelectTag,
    JSearchSelectTag,
    JEditor,
    JCategorySelect,
    RegexTest,
    Voice
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false,
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  mixins: [DisabledAuthFilterMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      testCase: [],
      showCase: false,
      currentCaseIndex: -1,
      currentCase:{},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      confirmLoading: false,
      validatorRules: {
        questionLibrary: {
          rules: [{ required: false, message: '请输入题库!' }],
        },
        questionName: {
          rules: [{ required: true, message: '请输入题目名!' }],
        },
        questionType: {
          rules: [{ required: true, message: '请输入题型!' }],
        },
        codeType: {
          rules: [{ required: true, message: '请选择代码类型!' }],
        },
        questionScore: {
          rules: [{ required: true, message: '请选输入参考分值!' }],
          initialValue: 0,
        },
        questionStatus: {
          rules: [{ required: true, message: '请选择状态!' }],
          initialValue: 1,
        },
        questionDifficulty: {
          rules: [{ required: true, message: '请输入难度!' }],
          initialValue: 1,
        },
        questionStem: {
          rules: [{ required: true, message: '请输入题干!' }],
        },
        timeLimit: {
          rules: [{ required: true, message: '请输入时间限制!' }],
          initialValue: 1,
        },
        memLimit: {
          rules: [{ required: true, message: '请输入内存限制!' }],
          initialValue: 64,
        },
        inputDesc: {
          rules: [{ required: true, message: '请输入输入描述!' }],
        },
        outputDesc: {
          rules: [{ required: true, message: '请输入输出描述!' }],
        },
        inputCase: {
          rules: [{ required: true, message: '请输入输入样例!' }],
        },
        outputCase: {
          rules: [{ required: true, message: '请输入输出样例!' }],
        },
      },
      url: {
        add: '/teaching/teachingQuestion/add',
        edit: '/teaching/teachingQuestion/edit',
        queryById: '/teaching/teachingQuestion/queryById',
      },
      questionStem: '',
      // questionAnswer: undefined,
      options: [{}],
      gapFillValue: [],
      keywordsValue: [],
      switchValue: false,
      radioValue: undefined,
      checkboxValue: undefined,
      dictOptions: [],
      tagConfig: null,
      editType: 0, //0编辑 1审核,
      taskInfo: null //命题任务
    }
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    },
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData()
    this.initDictConfig()
  },
  methods: {
    filterMultiDictText,
    initDictConfig() {
      loadCategoryData({ code: "A04" }).then((res) => {
        if (res.success) {
          this.$set(this.dictOptions, 'tag', res.result)
        }
      })
      loadCategoryData({ code: "A07" }).then((res) => {
        if (res.success) {
          this.$set(this.dictOptions, 'knowledgePoint', res.result)
        }
      })
    },
    onTagChange(value){
      // this.tagConfig = {}
      if(value){
        let values = value.split(',')
        for(let i in values){
          // 新增了标签但配置里没有
          if(!(values[i] in this.tagConfig)){
            this.tagConfig[values[i]] = {'score': 1}
          }else{
            // delete this.tagConfig[values[i]]
          }
        }
        
      }
      console.log(this.tagConfig);
    },
    questionStemChange(v) {
      this.questionStem = v
      let reg = /(_)\1{2,}/g
      let gap = v.match(reg)
      let gapNum = 0
      if (gap) {
        gapNum = gap.length
      }
      let nowGapNum = this.gapFillValue.length
      if (gapNum > nowGapNum) {
        //添加空位
        for (let i = 0; i < gapNum - nowGapNum; i++) {
          this.gapFillValue.push({})
        }
      } else if (gapNum < nowGapNum) {
        //删除空位
        for (let i = 0; i < nowGapNum - gapNum; i++) {
          this.gapFillValue.pop()
        }
      }
    },
    questionTypeChange(v) {
      this.model.questionType = v.target.value
      this.options = [{}]
      this.model.questionAnswer = undefined
    },
    addOption() {
      this.options.push({})
    },
    delOption(index) {
      this.options.splice(index, 1)
    },
    moveUpOption(index) {
      let t = this.options[index - 1]
      Vue.set(this.options, index - 1, this.options[index])
      Vue.set(this.options, index, t)
    },
    moveDownOption(index) {
      let t = this.options[index + 1]
      Vue.set(this.options, index + 1, this.options[index])
      Vue.set(this.options, index, t)
    },
    index2letter(index) {
      if (index < 0 || index > 25) {
        return ''
      }
      return String.fromCharCode(65 + index)
    },
    add(taskInfo) {
      this.tagConfig = null
      this.questionStem = ''
      this.options = [{}]
      this.gapFillValue = []
      this.switchValue = false
      this.radioValue = undefined
      this.checkboxValue = undefined
      this.keywordsValue = []
      this.testCase = []
      let record = {}
      if(taskInfo){
        record['questionType'] = taskInfo.questionType
        record['knowledgePoint'] = taskInfo.knowledgePoint
        record['questionDifficulty'] = taskInfo.questionDifficulty
        record['tag'] = taskInfo.tag
        record['questionLibrary'] = taskInfo.questionLibrary
      }
      this.edit(record, 0, taskInfo)
    },
    editById(id){
      this.add(null);
      this.confirmLoading = true
      getAction(this.url.queryById, {id: id}).then((res) => {
        if (res.success) {
          this.edit(res.result)
        }
        this.confirmLoading = false
      })
    },
    edit(record, editType, taskInfo) {
      console.log("question:review", this.isDisabledAuth('question:review'));

      this.editType = editType
      this.taskInfo = taskInfo
      console.log('record', record)
      this.form.resetFields()
      this.model = Object.assign({}, record)
      switch (parseInt(this.model.questionType)) {
        case 1: //单选
          if(this.model.questionOptions){
            this.options = JSON.parse(this.model.questionOptions)
          }
          this.radioValue = parseInt(this.model.questionAnswer)
          break
        case 2: //多选
          if(this.model.questionOptions){
            this.options = JSON.parse(this.model.questionOptions)
          }
          if(this.model.questionAnswer){
            this.checkboxValue = JSON.parse(this.model.questionAnswer)
          }
          break
        case 3: //判断
          this.switchValue = this.model.questionAnswer == 'true'
          break
        case 4: //填空
          if(this.model.questionAnswer){
            this.gapFillValue = JSON.parse(this.model.questionAnswer)
          }
          break
        case 5: //主观题
          if(this.model.questionAnswer){
            this.keywordsValue = JSON.parse(this.model.questionAnswer)
          }
          break
      }

      this.questionStem = this.model.questionStem
      if(this.model.tagConfig){
        this.tagConfig = JSON.parse(this.model.tagConfig)
      }else{
        this.tagConfig = {}
      }
      this.testCase = []
      if(this.model.testCase){
        this.testCase = JSON.parse(this.model.testCase)
      }
      
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'questionLibrary',
            'questionName',
            'knowledgePoint',
            'tag',
            'tagConfig',
            'questionType',
            'codeType',
            'questionDifficulty',
            'questionStem',
            'voiceText',
            'questionStemFile',
            'questionAnalysis',
            'questionAnalysisFile',
            'questionStatus',
            'unitId',
            'comment',
            'questionScore',
            'timeLimit',
            'memLimit',
            'inputDesc',
            'outputDesc',
            'inputCase',
            'outputCase',
            'taskId'
          )
        )
      })
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    submitForm() {
      switch (parseInt(this.model.questionType)) {
        case 1: //单选
          this.model.questionAnswer = this.radioValue
          break
        case 2: //多选
          this.model.questionAnswer = JSON.stringify(this.checkboxValue)
          break
        case 3: //判断
          this.model.questionAnswer = this.switchValue ? 'true' : 'false'
          break
        case 4: //填空
          this.model.questionAnswer = JSON.stringify(this.gapFillValue)
          this.options = {'fillGapNum':this.gapFillValue.length}
          break
        case 5: //主观题
          this.model.questionAnswer = JSON.stringify(this.keywordsValue)
          break
      }
      if (
        [1, 2, 3, 4].includes(this.model.questionType) &&
        (this.model.questionAnswer === undefined || this.model.questionAnswer === '')
      ) {
        this.$message.warning('请填写答案')
        return
      }
      this.model.questionOptions = JSON.stringify(this.options)
      this.model.tagConfig = JSON.stringify(this.tagConfig)
      this.model.questionStem = this.questionStem
      if(this.testCase.length>0){
        this.model.testCase = JSON.stringify(this.testCase)
      }
      if(this.taskInfo){
        this.model.taskId = this.taskInfo.id
      }
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok', that.model)
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'knowledgePoint',
          'questionType',
          'codeType',
          'questionDifficulty',
          'questionStem',
          'questionStemFile',
          'questionOptions',
          'questionAnswer',
          'questionAnalysis',
          'questionAnalysisFile',
          'unitId',
          'comment',
          'questionScore'
        )
      )
    },
    handleCategoryChange(value, backObj) {
      this.form.setFieldsValue(backObj)
    },
    addCase(){
      this.currentCaseIndex = this.testCase.length
      this.currentCase = {
        name: '测试用例' + parseInt(this.currentCaseIndex + 1),
        score: 0, //分数
        input: '', //输入参数
        output: '', //输出
        include: '', //包含关键词
        exclude: '', //不包含关键词
        reg: '', //正则
        regType: 'find' //正则模式
      }
      this.showCase = true
    },
    deleteCase(i){
      this.testCase.splice(i, 1)
      this.calcCaseScore()
    },
    editCase(i){
      this.currentCaseIndex = i
      this.currentCase = Object.assign({},this.testCase[i])
      this.currentCase.type = this.currentCase.type==2?2:1
      this.showCase = true
    },
    confirmCase(){
      Vue.set(this.testCase, this.currentCaseIndex, Object.assign({}, this.currentCase))
      this.showCase = false
      this.calcCaseScore()
    },
    closeCase(){
      this.showCase = false
      this.currentCaseIndex = -1
      this.currentCase = {}
    },
    calcCaseScore(){
      let score =this.testCase.reduce((score, curr)=>score + curr.score, 0)
      this.model.questionScore = score
      this.form.setFieldsValue({questionScore: score})
    },
    calcByte(str){
      var total = 0,
          charCode,
          i,
          len;
      for(i = 0, len = str.length; i < len; i++){
        charCode = str.charCodeAt(i);
        if(charCode <= 0x007f) {
        total += 1;
        }else if(charCode <= 0x07ff){
        total += 2;
        }else if(charCode <= 0xffff){
        total += 3;
        }else{
        total += 4;
        }
      }
      if(total < 1024){
        return total + "b"
      }else{
        return Math.round(total/1024) + "kb"
      } 
    },
    regexTest(regex, regType){
      this.$refs.regexTestModal.regex = regex
      this.$refs.regexTestModal.regType = regType
      this.$refs.regexTestModal.visible = true
    },
    testVoice(){
      this.form.getField
    }
  },
}
</script>

<style lang="less" scoped>
.ant-btn-circle {
  margin: 10px;
}
</style>